import React from 'react'
import { t } from 'i18next';
import { CustomModal } from '../../CustomModal/CustomModal';
import { URL_EXACTIAN, getTenantInfoByKey } from '../../../helpers/helpers';
import PermanenceTotals from '../PermanenceTotals/PermanenceTotals';
import PermanenceDetailTotals from './PermanenceDetailTotals';

const PermanenceDetailModal = ({ showModal, setShowModal, report }) => {

    const totals = {
        hs_50: report.total_hs_normal,
        hs_100: report.total_hs_100,
        hs_normal: report.total_hs_50
    };


    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            fullscreen
            style={{ padding: '0' }}
        >
            <div style={{ overflowX: 'hidden' }}>
                <div className='row pe-4 ps-4 pt-4'>
                    <div className="col">
                        <i
                            type='button'
                            onClick={setShowModal}
                            className="fa-solid fa-arrow-left fs-3"
                        >
                        </i>
                    </div>
                    <div className="col">
                        <h5 className={`m-0 custom-h4 text-nowrap text-sm-start fw-semibold`}>
                            {t('EMP_DETAIL')}
                        </h5>
                    </div>
                    <div className="col"></div>
                </div>
                <div className='mt-4 pe-4 ps-4'>
                    <div className='d-flex align-items-center gap-3'>
                        <img src={`${URL_EXACTIAN}Actions/img_proxy.php?idEMP=${report.employee_id}`}
                            alt={report.employee_natural_id}
                            style={{ width: '57px', height: '57px' }}
                        />
                        <div>
                            <span className='d-block blue-text'>
                                {report.employee_name}
                            </span>
                            <span className='d-block text-description'>
                                <strong>{getTenantInfoByKey('employee_id_lbl')} {report.employee_natural_id}</strong>
                            </span>
                        </div>
                    </div>

                </div>
                <div
                    className='mt-4 p-4'
                    style={{ background: '#EFF7FE' }}
                >
                    <div>
                        <div>
                            <span className='text-description'>
                                {t('CONT')}
                            </span>
                            <span className='d-block dark-text'>
                                {report.contractor_name} | {getTenantInfoByKey('contractor_id_lbl')} {report.contractor_natural_id}
                            </span>
                        </div>
                        <div>
                            <span className='text-description'>
                                {getTenantInfoByKey('hiring_modalities_name')}
                            </span>
                            <span className='d-block dark-text'>
                                {report.contract_type_employee}
                            </span>
                        </div>
                    </div>
                </div>
                <div className='mt-4 pe-4 ps-4'>
                    <PermanenceTotals haveDetail={false} totals={totals} />
                </div>
                <div className='mt-4'>
                    <h6 className='dark-text pe-4 ps-4'>
                        <strong>{t('RECORDS')} {report.total_records}</strong>
                    </h6>
                    <div
                        className="d-flex flex-column gap-2 no-show-scroll"
                        style={{ maxHeight: '450px', overflowY: 'auto' }}
                    >
                        {report.accessEmp.map((accessEmpDetail, idx) =>
                            <PermanenceDetailTotals
                                key={idx}
                                accessEmpDetail={accessEmpDetail}
                            />
                        )}
                    </div>
                </div>
            </div>
        </CustomModal>
    )
}

export default PermanenceDetailModal